import { render, staticRenderFns } from "./worldOffice-yopal.vue?vue&type=template&id=585c6e10"
import script from "./worldOffice-yopal.vue?vue&type=script&lang=js"
export * from "./worldOffice-yopal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports